<template>
  <cus-order-dialog>
    <template v-slot:body>
      <div class="table">
        <div class="table-head">
          <p style="text-align: left">標題</p>
          <p>通知日期</p>
        </div>

        <div class="h-100" :style="`display: grid; grid-template-rows: repeat(${pageItem}, ${100 / pageItem}%)`">
          <div
            :class="[`table-item`, selectId === item.id ? 'table-item-selected' : '']"
            v-for="(item, index) in renderList"
            :key="index"
            @click="handleOpenContent(item)"
          >
            <div>
              <div>
                <span v-if="item.status_code === 0" class="unread"></span>
                <p>{{ item.title }}</p>
              </div>
              <p>{{ item.create_datetime.slice(0, 16) }}</p>
            </div>
          </div>
        </div>
        <cus-page :totalPage="totalPage" v-model:currentPage="currentPage"></cus-page>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="關閉" color="white" style="padding: 0" @click="close()"></cus-button>
      </div>
    </template>
  </cus-order-dialog>

  <!-- 彈窗 -->
  <component :is="dialogTemplate"></component>
</template>
<script>
import { ref, inject, defineAsyncComponent, watch } from 'vue';
import { useDialog } from '@/utils/dialog';
import { useActions } from '@/utils/mapStore';
export default {
  name: 'notification',
  components: {
    Information: defineAsyncComponent(() => import('@/components/dialog/Information.vue')),
  },
  setup() {
    const close = inject('order_close');
    //設定參數
    const selectId = ref(null);
    const currentPage = ref(1);
    const pageItem = ref(12);
    const totalPage = ref(1);
    const renderList = ref([]);
    //取得訊息列表
    const doGetNotificationList = useActions('system', ['doGetNotificationList']);
    watch(
      currentPage,
      async () => {
        const res = await doGetNotificationList({
          start: (currentPage.value - 1) * pageItem.value,
          length: pageItem.value,
        });
        renderList.value = res.list;
        totalPage.value = Math.ceil(res.total / pageItem.value);
      },
      { immediate: true }
    );

    //開啟彈窗
    const { dialogVisible, dialogTemplate, openHeaderDialog } = useDialog();
    const doReadNotification = useActions('system', ['doReadNotification']);
    const handleOpenContent = async (item) => {
      selectId.value = item.id;
      await doReadNotification(item.id);
      item.status_code = 1;
      openHeaderDialog('notificationContent', {}, { dialogContent: item.content });
    };
    watch(dialogVisible, () => {
      if (!dialogVisible.value) selectId.value = null;
    });
    return {
      close,
      selectId,
      currentPage,
      pageItem,
      totalPage,
      renderList,
      dialogTemplate,
      handleOpenContent,
    };
  },
};
</script>
<style lang="scss" scoped>
.table {
  display: grid;
  grid-template-rows: 44px auto 70px;
  border: 2px solid $color-gray-10;
  border-radius: 4px;
  font-size: 1.8rem;
  @mixin table-rows-grid {
    display: grid;
    grid-template-columns: minmax(0, auto) 120px 200px;
    align-items: center;
    height: 100%;
  }
  &-head {
    @include table-rows-grid;
    padding: 0 15px;
    border-bottom: 2px solid $color-gray-10;
    height: 100%;
    background-color: $color-gray-3;
  }

  &-head > p:first-child {
    padding-left: 24px;
  }
  &-item {
    padding: 0 15px;
    cursor: pointer;
  }
  &-item > div {
    @include table-rows-grid;
    border-bottom: 1px solid $color-gray-10;
  }
  &-item > div > div:first-child {
    font-weight: 500;
    color: $color-blue;
    font-size: 2rem;
    display: flex;
    align-items: center;
    padding: 0 24px;
    position: relative;

    p {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .unread {
      position: absolute;
      left: 0;
      display: block;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: $color-yellow;
      margin-right: 12px;
    }
  }

  //選中樣式
  &-item-selected {
    background-color: $color-blue;
    color: #fff;
    p {
      color: #fff !important;
    }
  }
  &-item-selected > div {
    border-bottom: transparent;
  }
}
</style>
